import { CustomersDto } from '@/src/models/CustomersDto';
import DonationDto from '@/src/models/DonationDto';

export default class DonationParticipantsDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  donationCredit: number;
  isWinner: boolean;
  donation: DonationDto;
  customer: CustomersDto;
}
